import * as React from 'react';

import { PK } from 'common/types';
import { MEDIA_TYPES } from 'common/consts';
import { CollapsibleSection, MediaPicker, Title } from 'common/components';
import { useProgramMedia, useProgramMediaUpdate } from '../queries';

const fieldName = 'media_file_pks';

type Props = {
  pk?: PK;
};

const ProgramMediaPicker = ({ pk: programPk }: Props) => {
  const programMedia = useProgramMedia(programPk);
  const { mutate: save, isSuccess, isLoading, isError } = useProgramMediaUpdate();
  const saveStatus = { isSuccess, isLoading, isError };
  const defaultValues = programMedia.data?.images;

  const handleSave = (mediaPks: PK[]) => {
    if (programPk) {
      save({ pk: programPk, [fieldName]: mediaPks });
    }
  };

  return (
    <>
      <CollapsibleSection
        title="Add media"
        saveStatus={saveStatus}
        disabled={!programMedia.data}
      >
        <Title size="standard" marginBottom={1.5}>
          Linked image
        </Title>
        <MediaPicker
          name={fieldName}
          mediaType={MEDIA_TYPES.IMAGE}
          onSave={handleSave}
          defaultValues={defaultValues}
        />
      </CollapsibleSection>
    </>
  );
};

export default ProgramMediaPicker;
